import { useEffect } from "react";
import { ArrowRight } from "lucide-react";
import OrbitHero from "./OrbitHero";
import WorkspaceShowcaseSection from "./WorkspaceShowcaseSection";
import LiveWorkflowSection from "./LiveWorkflowSection";
import HeroClosingSection from "./HeroClosingSection";
import ConnectedSuiteBridge from "./ConnectedSuiteBridge";
import UnifiedWorkspaceSection from "./UnifiedWorkspaceSection";
import SiteHeader from "./SiteHeader";
import { productHref } from "../data/products";

export default function HeroPage() {
  useEffect(() => {
    const html = document.documentElement;
    const previousRestoration = window.history.scrollRestoration;

    html.classList.add("hero-page-snap-active");
    window.history.scrollRestoration = "manual";

    const moveToTop = () => window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    moveToTop();
    const frame = window.requestAnimationFrame(moveToTop);

    return () => {
      window.cancelAnimationFrame(frame);
      html.classList.remove("hero-page-snap-active");
      window.history.scrollRestoration = previousRestoration;
    };
  }, []);

const webPageSchema = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://cullath.com/#organization",
    "name": "Cullath",
    "url": "https://cullath.com",
    "logo": "https://cullath.com/cullath-nav-logo.png",
    "description":
      "Cullath is a unified workplace collaboration platform that helps businesses communicate, collaborate, manage workflows, and provide remote support through one secure cloud-based solution."
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": "https://cullath.com/#website",
    "url": "https://cullath.com",
    "name": "Cullath",
    "description":
      "Cullath is a unified workplace collaboration platform that helps businesses communicate, collaborate, manage workflows, and provide remote support through one secure cloud-based solution.",
    "publisher": {
      "@id": "https://cullath.com/#organization"
    },
    "inLanguage": "en"
  },
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": "https://cullath.com/#webpage",
    "url": "https://cullath.com/",
    "name": "Team Collaboration Tools & Workplace Platform | Cullath",
    "description":
      "Cullath is a unified workplace collaboration platform that helps businesses communicate, collaborate, manage workflows, and provide remote support through one secure cloud-based solution.",
    "isPartOf": {
      "@id": "https://cullath.com/#website"
    },
    "about": {
      "@id": "https://cullath.com/#organization"
    },
    "inLanguage": "en"
  }
];
  return (
    <div className="hero-page-shell">
      <SiteHeader isHeroPage 
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(webPageSchema),
      }}/>

      <main>
        <section className="orbit-hero-section">
          <div className="hero-space-stars" aria-hidden="true" />
          <div className="hero-space-grid" aria-hidden="true" />
          <div className="hero-space-floor" aria-hidden="true" />
          <div className="hero-backdrop-arc hero-backdrop-arc--one" aria-hidden="true" />
          <div className="hero-backdrop-arc hero-backdrop-arc--two" aria-hidden="true" />
          <div className="hero-backdrop-arc hero-backdrop-arc--three" aria-hidden="true" />

     <div className="page-container orbit-hero-layout">
  <section
    className="orbit-hero-copy"
    aria-labelledby="cullath-hero-title"
  >
    <div className="orbit-hero-kicker">
      <i aria-hidden="true" />
      WHERE WORK ORBITS.
    </div>

    <h1 id="cullath-hero-title">
      <span className="hero-title-line">
        Connect. Collaborate.
      </span>

      <span className="hero-title-gradient">
        Get Work Done.
      </span>
    </h1>

    <p>
    Cullath brings team collaboration tools, messaging, remote support, and workflow management together in one connected 
    workplace platform—helping modern teams communicate, collaborate, and get work done from a single workspace.
    </p>

    <div className="orbit-hero-actions">
<a
  className="orbit-primary-cta"
  href="https://connect.cullath.com"
  target="_blank"
  rel="noopener noreferrer"
>
  Sign Up <ArrowRight size={18} />
</a>

      <a
        className="orbit-secondary-cta"
        href="https://connect.cullath.com/desktop/Cullath.exe"
      >
        Download <ArrowRight size={18} />
      </a>
    </div>
  </section>

  <div className="orbit-hero-animation">
    <OrbitHero />
  </div>
</div>
        </section>
        <UnifiedWorkspaceSection />
        {/* <ConnectedPlatformSection /> */}
        <WorkspaceShowcaseSection />
        <ConnectedSuiteBridge />
        <LiveWorkflowSection />

        <HeroClosingSection />

      </main>
    </div>
  );
}
